var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfileBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15.5,
    viewBox: "0 0 14 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_105_account_C",
    "data-name": "105_account_C",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11070",
    "data-name": "\\u30D1\\u30B9 11070",
    d: "M9.5,9A4.5,4.5,0,1,0,5,4.5,4.5,4.5,0,0,0,9.5,9Zm0-8A3.5,3.5,0,1,1,6,4.5,3.5,3.5,0,0,1,9.5,1Z",
    transform: "translate(-2.5)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11071",
    "data-name": "\\u30D1\\u30B9 11071",
    d: "M14,26V25c.045-2.76-3.135-5-7-5s-7,2.24-7,5v1H1V25H1c0-2.17,2.745-4,6-4a7.154,7.154,0,0,1,5.045,1.835A3.054,3.054,0,0,1,13,25h0v1Z",
    transform: "translate(0 -10.5)",
    fill: "#377EF3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileBlue);
export default __webpack_public_path__ + "static/media/icon_profile_blue.aad636eab0db59114cf785ebb7430bc6.svg";
export { ForwardRef as ReactComponent };